function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "payment-success");

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "#BBE5B3",
  cx: 16,
  cy: 16,
  r: 16
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFF",
  cx: 16,
  cy: 16,
  r: 9
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#108043",
  d: "M16 26c-5.523 0-10-4.477-10-10S10.477 6 16 6s10 4.477 10 10c-.006 5.52-4.48 9.994-10 10zm0-18c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8c-.005-4.416-3.584-7.995-8-8z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#108043",
  d: "M15 19c-.265 0-.52-.105-.707-.293l-2-2c-.374-.407-.347-1.04.06-1.413.383-.352.972-.352 1.354 0L15 16.587l3.293-3.29c.397-.385 1.03-.374 1.414.024.374.388.374 1.002 0 1.39l-4 4c-.188.186-.442.29-.707.29z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/success.0d57cd5f.svg";
export { SvgComponent as ReactComponent };